import cookie from 'js-cookie';

class StorageService {
  getLanguageCode = () => {
    return cookie.get('CK_LANG_CODE');
  };
}

export const storageService = new StorageService();
